export default {
  status: "Status",
  accessStatus: "Access Status",
  stockStatus: "Stock Status",
  followUpStatus: "Follow-up Status",
  editStatus: "Edit Status",
  blacklistStatus: "Attention List Status",
  day: "Day",
  hour: "Hour",
  minute: "Minute",
  safetyPoint: "Safety Point",
  rewardPoint: "Rewards Point",
  createdAt: "Created Date",
  updatedAt: "Updated Date",
  lastUpdatedAt: "Last Updated",
  Error: "Error",
  unKnowError: "Unknown Error. Please try again.",
  nameEn: "Name (Eng)",
  nameZh: "Name (Chi)",
  nameZhCHS: "Name (CHS)",
  descriptionEn: "Description (Eng)",
  descriptionZh: "Description (Chi)",
  descriptionZhCHS: "Description (CHS)",
  remarks: "Remarks",
  remarkEn: "Remark (Eng)",
  remarkZh: "Remark (Chi)",
  remarkZhCHS: "Remark (CHS)",
  constructionSite: "Construction Site",
  titleEn: "Title (Eng)",
  titleZh: "Title (Chi)",
  titleZhCHS: "Title (CHS)",
  contentEn: "Content (Eng)",
  contentZh: "Content (Chi)",
  contentZhCHS: "Content (CHS)",

  Popup: {
    created: "The record was successfully created.",
    updated: "The record was successfully updated.",
    deleted: "The record was successfully deleted.",
    uploaded: "The file was successfully uploaded.",
    imported: "The record was successfully imported.",
    sent: "The sms was successfully sent",
    canceled: "The booking was successfully cancelled",
    generated: "The information was successfully generated.",
    confirmationNoteResent: "The confirmation notice was successfully resent.",
    terminated: "The booking was successfully terminated",
    unsaved: "Unsaved Changes",
    leaveWithoutSaving: "Leave without saving",
    confirmDelete: "Confirm to delete the record?",
    areYouSure: "Are you sure?",
    lostDataWarning:
      "You are about to leave this page without saving.\nAll changes will be lost.\nDo you really want to leave without saving?",
    bathUploadFailed: "File number {{number}} upload failed, please try again.",
    unKnow: "Unknown Error. Please try again.",
    getResponseTimeout: "Request Timeout, Please try again later",
  },
  Button: {
    save: "Save",
    update: "Update",
    close: "Close",
    cancel: "Cancel",
    reset: "Reset",
    search: "Search",
    delete: "Delete",
    confirm: "Confirm",
    add: "Add",
    back: "Back",
    refresh: "Refresh",
    redirect: "Redirect",
    logout: "Log Out",
    downloadCSV: "Download CSV",
    download: "Download",
    generate: "Generate",
    submit: "Submit",
    preview: "Preview",
  },
  Status: {
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    pendingApproval: "Pending Approval",
    suspended: "Suspended",
    completed: "Completed",
    rejected: "Rejected",
    approved: "Approved",
    updatedAt: "Last updated",
    submitted: "Pending",
    confirmed: "Awaiting Pickup",
    delivered: "Received",
    cancelled: "Cancelled",
    paid: "Paid",
    unpaid: "Unpaid",
    inStock: "Normal",
    lowStock: "Low in Stock",
    outOfStock: "Out of Stock",
    takenDown: "Taken Down",
    success: "Success",
    fail: "Fail",
    approve: "Approve",
    reject: "Reject",
    voided: "Voided",
    pendingToVoid: "Pending To Void",
    processing: "Processing",
    cleared: "Offset",
    failed: "Failed",
    error: "Error",
  },
  Menu: {
    Home: "Home",
    Admins: "Admins",
    PointManagement: "Point Management",
    RiskReport: "Risk Report",
    RiskManagement: "Risk Management",
    UserGroup: "CMS Permission Control",
    Users: "App Users",
    SystemOptions: "System Options",
    Certificate: "Certificate",
    SiteAndZone: "Site & Zone",
    Courses: "Course",
    UserDetail: "App User Detail",
    UserPoint: "User and Point Details",
    ZonePoint: "Zone Point Details",
    MyAccount: "My Account",
    Test: "Test",
    ContentUpdate: "Content Update",
    SubContractor: "Company",
    TotalOf: "Total of",
    NumberOfSearchResults: "search results",
    Tags: "Tags",
    Report: "Reporting",
    TrainingReport: "Additional Training Report",
    PointMart: "Point Mart",
    StoreManagement: "Store Management",
    StoreManagementDetail: "Product List",
    ProductDetail: "Product",
    OrderManagement: "Order Management",
    OrderManagementDetail: "Order List",
    OrderDetail: "Order Detail",
    ProductCategory: "Product Category",
    SafetyPointManagement: "Safety Point Records",
    SafetyPointManagementDetail: "Safety Point Detail",
    RewardPointManagement: "Rewards Point Records",
    RewardPointManagementDetail: "Rewards Point Detail",
    ReportAndDownload: "Reporting & Download",
    BreachRecord: "Site Access Right",
    Company: "Client and Main-Con",
    Advertisement: "ADs Control",
    Configuration: "System Setting",
    ImportBatch: "Import Batch",
    SafetyPoint: "Safety Point",
    RewardPoint: "Rewards Point",
    Blacklist: "Attention List",
    NotificationTemplate: "Notification Content",
  },
  Auth: {
    welcome: "Welcome!",
    login: "Login",
    forgotPwd: "忘記密碼",
    tnc: "登錄即表示您同意我們的使用條款並接收電子郵件、更新並確認您已閱讀我們的隱私政策。",
  },
  Home: {
    welcome: "歡迎來到BuildSafe。",
  },
  Users: {
    id: "ID",
    name: "English Name",
    chineseName: "Chinese Name",
    phone: "Phone Number",
    code: "Code",
    role: "Role",
    viewSafetyPoint: "Safety Point Records",
    viewRewardPoint: "Rewards Point Records",
    displayCode: "Display QR Code",
    qrCode: "User QR Code",
    basicInfo: "Basic Information",
    hkid: "HKID No.",
    workInfo: "Work Information",
    userId: "User ID",
    hkie: "The Hong Kong Institution of Engineers",
    hkicm: "The Hong Kong Institute of Construction Managers",
    cwrc: "Construction Workers Registration Card",
    cistc: "Construction Industry Safety Training Certificate (Green Card)",
    hkis: "The Hong Kong Institute of Surveyors",
    hkila: "The Hong Kong Institute of Landscape Architects",
    hkia: "The Hong Kong Institute of Architects",
    cistcAlt: "Green Card or Other Equivalent Certificates",
    refNumber: "Card Number",
    cardName: "Name",
    memberShip: "Membership Class",
    dateOfCompletion: "Course Completion Date",
    validFrom: "Valid From",
    validTo: "Valid To",
    expiryDate: "Expiry Date",
    dateOfIssue: "Date Of Issue",
    siteInfo: "Site",
    expandAll: "Expand All",
    addZone: "Add New",
    allZone: "All Zone",
    zone: "Zone",
    updatedAt: "Last Updated",
    createdAt: "Created Date",
    username: "Email Address (for Login)",
    password: "Password",
    confirmPassword: "Confirm Password",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    authInfo: "Login Information",
    phoneChecking: "Check Phone Number",
    roleSelection: "Select Position",
    infoSetting: "Info Setting",
    position: "Position",
    dateOfBirth: "Date Of Birth",
    gender: "Gender",
    f: "Female",
    m: "Male",
    preferredLanguage: "Preferred Language",
    userNotFound: "User not found. User must send an otp in the app first.",
    userExist:
      "The user has already registered. Please enter the correct phone number.",
    selectCard: "Please select the certificate you hold",
    cardType: "Card Type",
    en: "English",
    zh: "繁體中文",
    zhCHS: "简体中文",
    phoneExist: "The phone number has already been registered.",
    SubContractor: "Company",
    Site: "Construction Site (For filter)",
    dateOfRegistration: "Date of Registration",
    serialNumber: "Serial Number (Back of the card)",
    permissionGroup: "Role (Permission User Group)",
    adminName: "Admin Name",
    companyName: "Client and Main-Con Name",
    companyType: "Company Type",
    roleUserGroup: "Role (User Group)",
    verifyUser: "Verify User",
    importAppUsers: "Bulk Registration",
    source: "Created By",
    app: "Mobile App",
    import: "Bulk Registration",
    cms: "CMS",
    system: "System",
    addBlacklist: "Add to Attention List",
    blacklistInfo: "Blacklist Information",
    addBlacklistWithoutRegister: "Add to Attention List without Registration",
    blacklisted: "Blacklisted",
    employeeId: "Employee ID",
  },
  RiskReport: {
    id: "Report ID",
    title: "Title",
    location: "Location",
    createdAt: "Report Date",
    reportInfo: "Report Information",
    status: "Status",
    remarks: "Remarks",
    description: "Description",
    reporter: "Reported By",
    handler: "Handled By",
    updatedAt: "Last Updated",
    pointItem: "Point Item",
    point: "Point",
    approvedPointItem: "Approved Point Item",
  },
  Role: {
    unknown: "Unknown",
    cmsAdmin: "CMS Admin",
    siteAdmin: "Site Admin",
    manager: "Manager",
    safetyAdmin: "Safety Admin",
    worker: "Worker",
    frontline: "Clerical",
    external: "External",
    otherOfficeStaff: "Other Clerical Staff",
    frontlineSupervisor: "Frontline Supervisor",
  },
  Courses: {
    name: "Name",
    contentEn: "Content (Eng)",
    contentZh: "Content (Chi)",
    contentZhCHS: "Content (CHS)",
    credit: "Credit",
    offset: "No. of points offset",
    pointItemName: "Point Name",
    pointItemType: "Point Type",
    pointItemValue: "Point Value",
    course: "Course",
    training: "Additional Training Report",
    category: "Type",
    photo: "Photo",
    pointDeduction: "Point Related",
    pointItem: "Point Item",
    duration: "Duration",
    languageEn: "Language (Eng)",
    languageZh: "Language (Chi)",
    languageZhCHS: "Language (CHS)",
    url: "Website Url",
    priority: "Priority",
  },
  Certificate: {
    title: "Title",
    user: "User",
    type: "Type",
    id: "Certificate ID",
    createdAt: "Report Date",
    phone: "Phone Number",
    certificate: "Certificate",
    reporter: "Reported By",
    description: "Description",
    reason: "Reason",
    remarks: "Remarks",
    course: "Course",
    training: "Training Records",
  },
  PointManagement: {
    User: "User",
    Zone: "Zone",
    name: "Name",
    chineseName: "Chinese Name",
    phone: "Phone Number",
    userId: "User ID",
    safetyPoint: "Safety Point",
    rewardPoint: "Rewards Point",
    FilterBySiteOrZone: "Filter by Site or Zone",
    total: "Total",
    points: " Points",
    inspectUserProfile: "Go to Profile",
    belongingConstructionSite: "Belonging construction sites",
    createdDate: "Created Date",
    description: "Description",
    none: "None",
    good: "Good",
    slight: "Slight",
    moderate: "Moderate",
    severe: "Severe",
    severity: "Severity",
    credit: "Credit",
    onlyLast12Months: "Only points from the past twelve months are recorded",
    rewardPoints: "Rewards Points",
    totalPoints: "Points for All Sites",
    decisions: "Decisions",
    decidedBy: "Decided By",
    decidedAt: "Decided At",
    void: "Void",
    confirmToVoid: "Confirm to void this safety score?",
    addSafetyPoint: "Add Safety Score",
    safetyPointItem: "Offence in Operations",
    point: "Point",
    addRewardPoint: "Add Rewards Point",
    rewardPointItem: "Reason for Rewards",
  },
  SubContractor: {
    name: "Name",
    code: "Code",
  },
  Configuration: {
    en: "English",
    zh: "Chinese",
    zhCHS: "Simplified Chinese",
    page: "Page",
    configuration: "Configuration",
    contentUpdate: "Content Update",
    projectType: "Project Type",
    tnc: "Terms and Conditions",
    pp: "Privacy Policy (not implemented)",
    constructionSite: "Construction Site Configuration",
    defaultLogo: "Default Logo",
    breachRecord: "Site Access Right Configuration",
    gracePeriod: "Course Enrollment Grace Period",
    days: "Day(s)",
    gracePeriodReminder:
      "* Set to 0 days, the button of block will be appeared immediately.",
    advertisement: "ADs Control Configuration",
    displayDuration: "ADs Display Time",
    durationReminder:
      "* Set 0 seconds will enable the user to close the banner immediately.",
    seconds: "Second(s)",
    bulkRegistration: "Bulk Registration Configuration",
    tncLink: "T & C Link",
    name: "Name",
  },
  Validation: {
    required: "Required",
    invalidPhone: "Invalid Phone Number",
  },
  Report: {
    rewardPointTransaction: "Daily Rewards Point Download",
    safetyPointTransaction: "Daily Safety Point Download",
    from: "From",
    to: "To",
    user: "App User Download",
  },
  StoreManagement: {
    name: "Name",
    siteCode: "Code",
    point: "No. of Point Required",
    lowInStock: "Low Stocks Alert",
    availableStock: "Available Stock",
    reservedStock: "Reserved Stock",
    Medias: "Photos",
    availableFrom: "Valid From",
    availableTo: "Valid To",
    basic: "Basic Info",
    stock: "Stock Info",
    media: "Photos",
    SKUID: "Product Code",
    unitEn: "Unit (Eng)",
    unitZh: "Unit (Chi)",
    unitZhCHS: "Unit (CHS)",
    siteId: "Site ID",
    productId: "Product ID",
    totalStock: "Total Stock",
    remark: "Remark",
    store: "Store",
    changeAvailableStock: "Change Stock",
    add: "Add Stock (+)",
    reduce: "Reduce Stock (-)",
    type: "Type",
    expectedAvailableStock: "Expected Available Stock",
    unlimited: "Unlimited",
    productName: "Name",
    productCategory: "Product Category",
  },
  OrderManagement: {
    name: "Name",
    orderRef: "Order Reference Number",
    inspectUserProfile: "Go to Profile",
    displayOrderCode: "Display Order Code",
    basicInfo: "Basic Information",
    cartInfo: "Cart Information",
    productName: "Product Name",
    quantity: "Quantity",
    phoneNumber: "Phone Number",
    orderId: "Order ID",
    orderStatus: "Order Status",
    paidStatus: "Paid Status",
    user: "User",
    siteName: "Site Name",
    totalPoints: "Total Points",
    amount: "Amount",
    createdAt: "Created At",
    updatedAt: "Last Updated",
    remarks: "Remarks",
    redemptionPhoto: "Redemption Photo",
  },
  ProductCategory: {
    code: "Code",
  },
  UserGroup: {
    name: "Name",
    code: "Code",
    level: "Level",
    personal: "Personal",
    organization: "System Owner",
    company: "Client and Main-Con",
    site: "Project Site",
    allGranted: "All Granted",
    read: "Read",
    create: "Create",
    update: "Update",
    delete: "Delete",
    inactiveReminder:
      "* Please ensure no users are assigned to this permission user group. ",
    selectedCompany: "Company",
  },
  ConstructionSite: {
    name: "Site Name",
    code: "Code",
    protocol: "Protocol",
    domain: "Domain",
    token: "Token",
    basicInfo: "Site Information",
    gateInfo: "Gate Information",
    eShopEnabled: "E-Shop Enabled",
    logo: "Logo",
    isJointVenture: "Joint Venture",
    zoneInfo: "Zones",
    zoneName: "Zone Name",
    zone: "Zone",
    gateContractor: "Gate Contractor",
    synergos: "Synergos",
    timeExpert: "Time Expert",
    cerebro: "Cerebro",
    gateContractorEnabled: "Gate Contractor Enabled",
    uploadReminder: "* Please upload photo dimensions within 600 x 220",
    supervisor: "Supervisor",
    companyInfo: "Client and Main-Con Information",
    mainConCompany: "Main Contractor",
    relatedMainConOwner: "Related Main Contractor Owner Companies",
    clientCompanies: "Clients",
    otherClientCompanies: "Clients",
    mainConCompanies: "Main Contractors",
    siteAccessRightEnabled:
      "Mobile App Site Access Right Enabled (For Site Admin)",
    removeMainConAccess: "Remove access right for Main Con",
    restoreMainConAccess: "Recover access right for Main Con",
    reminderMainConAccess:
      "Changing Main Con will prevent the Project CMS Admin from accessing the site.",
    confirmToRemoveMainConAccess:
      "Confirm to remove the access right for Main Con?",
    confirmToRestoreMainConAccess:
      "Confirm to recover access right for Main Con?",
    mainConAccessRightEnabled:
      "* No access right for Main Con. Please contact the super admin for further assistance.",
    mainConAccessStatus: "Main Con Access Status",
    removedBySite: "Removed by site",
    normal: "Normal",
    generateQrCode: "Registration QR Code",
    qrCode: "QR Code",
    removeMainConAccessReminder:
      "Removing access rights for the Main Con can no longer update the Main Con info. If you need to update the Main Con info, please contact the 'System Admin' to recover access rights.",
    canSkipPointTransactionApproval:
      "Skip Approval for Safety & Rewards Points",
    primaryMainContractor: "Primary Main Con (Safety & Rewards Point)",
    blockUnblockFeature: "Block & Unblock Feature",
    projectType: "Project Type",
    isHKIDScanRequired: "HKID Scan Mandatory",
    siteAccessRightForAllUsersEnabled:
      "Mobile App Site Access Right Enabled (For All Users)",
    syncEmployee: "Sync Employee ID from Gate",
    syncEmployeeHistory: "Sync Employee History",
    limit: "Counts",
    page: "Page",
  },
  BreachRecord: {
    totalPoints: "Safety Points",
    lastUpdatedBy: "Last Updated By",
    updatedBy: "Updated By",
    uploadedCert: "Uploaded Certificates",
    status: "Status",
    createdAt: "Date Reached 15 Points",
    remarks: "Remarks",
    courseDate: "Reserved Attending Date",
    title: "Title",
    description: "Description",
    actionLog: "Action Log",
    action: "Action",
    lastRefresh: "Last refresh date",
    changeStatus: "Status Changed",
    cancelEnrolment: "Cancel Enrolment",
    uploadCertificate: "Upload Certificate",
    rejectCertificate: "Reject Certificate",
    approveCertificate: "Approve Certificate",
    uploadEnrolmentProof: "Upload EnrolmentProof",
    balanceBelowThreshold: "Below 15 Points",
    balanceAboveThreshold: "Reached 15 Points",
    blockUser: "Block User",
    unblockUser: "Unblock User",
    enrolmentInfo: "Improvement Course Details",
    statusInfo: "Status Info",
    photo: "Photo",
    cwrc: "CWRC Number",
    gateBlockUser: "Block User by Gate",
    gateUnblockUser: "Unblock User by Gate",
    blockRemarks: "Block Remarks",
    blockedDate: "Blocked Date",
    pendingForEnrolment: "Pending for Enrolment",
    pendingForUploadCertificate: "Pending for Upload Certificate",
    pendingForCertificateApproval: "Pending for Certificate Approval",
    certificateApproved: "Certificate Approved",
    cleared: "Auto Cleared",
    manuallyCleared: "Manually Cleared",
    blocked: "Blocked",
    unblocked: "Access Allowed",
    blockedByGate: "Blocked by Gate System",
  },
  Company: {
    id: "ID",
    type: "Company Type",
    name: "Name",
    code: "Code",
    client: "Client",
    mainContractorOwner: "Main Contractor Owner",
    mainContractor: "Main Contractor",
    layer2: "Client",
    layer3: "Main Contractor",
    searchType: "Search Company Type",
    mainConOwnerCompanies: "Main Contractor Owner Companies",
  },
  Advertisement: {
    Image: "Image",
    priority: "Priority",
    validFrom: "Valid From",
    validTo: "Valid To",
    visibleTo: "User Types for Viewing Ads",
    url: "Links",
    name: "Name",
    uploadReminder: "* Support JPG and PNG",
  },
  ImportBatch: {
    uploadAppUsers: "Upload App Users",
    template: "Template",
    downloadTemplate: "Generate Excel",
    uploadExcel: "Upload Excel",
    previewUploadedFile: "Preview Uploaded File",
    importUploadedFile: "Confirm Import User",
    row: "Row",
    rawData: "Raw Data",
    errorMessage: "Error Message",
    confirmImportHeader: "Confirm to Add User",
    confirmToImport1:
      "Please check and confirm if the inputted information is correct. Please let users acknowledge and confirm ",
    confirmToImport2: " before creating their account.",
    history: "Bulk Registration History",
    previewResults: "Preview Results",
    importResults: "Import Results",
    total: "Total",
    items: "item(s)",
    previewStatus: {
      completed: "Passed",
      failed: "Incomplete",
      pending: "Pending",
    },
    importStatus: {
      completed: "Completed",
      failed: "Failed",
      pending: "Pending",
    },
  },
  PointItem: {
    safetyPoint: "Safety Point",
    rewardPoint: "Rewards Point",
    reason: "Reason",
    point: "Point",
    category: "Category",
    reasonEn: "Reason (Eng)",
    reasonZh: "Reason (Chi)",
    pointNumber: "No. of Point",
    value: "Value",
    type: "Type",
    action: "Action",
    credit: "Credit (-)",
    debit: "Debit (+)",
    priority: "Priority",
    rewardsPointDebit: "Rewards Debit",
    riskReport: "Rewards Debit (Risk Report)",
    trainingReport: "Rewards Debit (Additional Training Report)",
    isGlobal: "Is Global Item",
    global: "Global",
    mainContractor: "Main-Con",
    range: "Range",
  },
  Blacklist: {
    cwrcRef: "CWRC Number",
    blacklistedBySite: "Updated By Site",
    actionLog: "Action Logs",
    remove: "Remove from Attention List",
    action: "Action",
    updatedBy: "Updated By",
    remarks: "Reason",
    confirmRemoveBlacklist: "Confirm to remove from attention list?",
    confirmAddToBlacklist: "Confirm to add to attention list?",
    user: "User",
    active: "Active",
    removed: "Removed",
    blacklisted: "Active",
    addToBlacklist: "Add to Attention List",
    removeFromBlacklist: "Remove from Attention List",
    changeStatus: "Status Changed",
    siteByProfile: "Construction Site (By User Profile)",
  },
  NotificationTemplate: {
    type: "Type",
    topic: "Topic",
    name: "Name",
    code: "Code",
    inApp: "In App",
    push: "Push",
    sms: "SMS",
    otp: "OTP",
    weatherWarning: "Weather Warning",
    heatStressWarning: "Heat Stress Warning",
    personalGreenCardExpiry: "Green Card Expiry Reminder",
    personalCwrcCardExpiry: "CWRC Card Expiry Reminder",
    siteUserGreenCardExpiry: "Green Card List for Admin",
    personalGreenCardRenewal: "Green Card Renewal Notice",
    pendingRiskReportSummary: "Pending Risk Reports",
    pendingCourseCertificateSummary:
      "Pending Safety Improvement Course Certificates",
    riskReportApproved: "Risk Report Approved",
    riskReportRejected: "Risk Report Rejected",
    reachSafetyPointThreshold: "Safety Points Reached 10",
    reachMaxSafetyPoint: "Safety Points Reached 15 or Above",
    siteUserReachSafetyPointThreshold: "Users with 10 Safety Points Summary",
    siteUserReachMaxSafetyPoint: "Users with 15+ Safety Points Summary",
    siteUserReachSafetyPointThresholdEnterSite:
      "Site User Reach Safety Point Threshold Enter Site",
    siteUserCompletedTrainingCourseEnterSite:
      "Site User Completed Training Course Enter Site",
    siteUserAccessReviewRequired: "Site User Access Review Required",
    courseCertificateApproved: "Safety Improvement Course Certificate Approved",
    courseCertificateRejected: "Safety Improvement Course Certificate Rejected",
    safetyPointLogged: "New Safety Performance Point Logged",
    rewardPointAwarded: "New Reward Points Awarded",
    siteUserBlacklistedEnterSite: "Site User Blacklisted Enter Site",
    siteUserBlacklisted: "Site User Blacklisted",
  },
};
